import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=50f32c58&scoped=true"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"
import style0 from "./Form.vue?vue&type=style&index=0&id=50f32c58&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f32c58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50f32c58')) {
      api.createRecord('50f32c58', component.options)
    } else {
      api.reload('50f32c58', component.options)
    }
    module.hot.accept("./Form.vue?vue&type=template&id=50f32c58&scoped=true", function () {
      api.rerender('50f32c58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/globals/aspectos/Form.vue"
export default component.exports